import { useTranslation } from 'react-i18next'

type FrontendRoutingLink = {
	to: string
	title: string
}

type ExternalLink = {
	href: string
	title: string
	noFollow?: boolean
	isExternal?: boolean
}

export type Link = FrontendRoutingLink | ExternalLink

export const useLinks = (): {
	areaLinks: Link[]
	learnMoreLinks: Link[]
	infoLinks: Link[]
} => {
	const { t } = useTranslation()

	const areaLinks: Link[] = [
		{
			href: `${t('/lediga-kontor', { ns: 'url' })}/stockholm`,
			title: `${t('Kontor')} Stockholm`,
		},
		{
			href: `${t('/lediga-kontor', { ns: 'url' })}/göteborg`,
			title: `${t('Kontor')} Göteborg`,
		},
		{
			href: `${t('/lediga-kontor', { ns: 'url' })}/malmö`,
			title: `${t('Kontor')} Malmö`,
		},
		{
			href: `${t('/lediga-kontorshotell', { ns: 'url' })}/stockholm`,
			title: `${t('Kontorshotell')} Stockholm`,
		},
		{
			href: `${t('/lediga-kontorshotell', { ns: 'url' })}/göteborg`,
			title: `${t('Kontorshotell')} Göteborg`,
		},
		{
			href: `${t('/lediga-kontorshotell', { ns: 'url' })}/malmö`,
			title: `${t('Kontorshotell')} Malmö`,
		},
		{
			href: `${t('/lediga-kontor', { ns: 'url' })}/uppsala`,
			title: `${t('Kontor')} Uppsala`,
		},
		{
			href: `${t('/lediga-kontor', { ns: 'url' })}/lund`,
			title: `${t('Kontor')} Lund`,
		},
		{
			href: `${t('/lediga-kontorshotell', { ns: 'url' })}/helsingborg`,
			title: `${t('Kontorshotell')} Helsingborg`,
		},
		{
			href: `${t('/lediga-kontorshotell', { ns: 'url' })}/jönköping`,
			title: `${t('Kontorshotell')} Jönköping`,
		},
		{
			href: `${t('/lediga-kontorshotell', { ns: 'url' })}/linköping`,
			title: `${t('Kontorshotell')} Linköping`,
		},
	]

	const learnMoreLinks: Link[] = [
		{
			href: '/kontorshjalpen',
			title: 'Prata med en expert',
		},
		{
			href: '/blogg/tag/guider-att-valja-ratt-kontor',
			title: 'Guider - att välja rätt kontor',
			isExternal: true,
		},
		{
			href: '/content/vad-är-coworking',
			title: 'Vad är coworking?',
		},
		{
			href: '/blogg/tag/coworking-stad-for-stad',
			title: 'Bästa coworking stad för stad',
			isExternal: true,
		},
		{
			href: '/blogg/guide-hur-fungerar-ett-hyresavtal-pa-kontorshotell',
			title: 'Hyresavtal på kontorshotell',
			isExternal: true,
		},
		{
			href: '/blogg/tag/hyresnivaer-stad-for-stad',
			title: 'Hyresnivåer stad för stad',
			isExternal: true,
		},
		{
			href: '/blogg/guide-coworking-for-storre-foretag',
			title: 'Coworking för större företag',
			isExternal: true,
		},
		{
			href: '/blogg/guide-medlemskap-pa-coworking',
			title: 'Guide - Medlemskap på coworking',
			isExternal: true,
		},
	]
	const infoLinks: Link[] = [
		{
			href: '/om',
			title: 'Om oss',
		},
		{
			href: '/blogg',
			title: 'Blogg',
			isExternal: true,
		},
		{
			href: '/blogg/tag/referenser',
			title: 'Referenser och case',
			isExternal: true,
		},
		{
			href: '/content/hybridarbete',
			title: 'Våra tjänster',
		},
		{
			href: '/content/väx-er-coworking',
			title: 'Hyr ut',
		},
		{
			href: '/blogg/tag/marknadsrapporter',
			title: 'Marknadsrapporter om coworking',
			isExternal: true,
		},
	]

	return {
		areaLinks,
		learnMoreLinks,
		infoLinks,
	}
}
